import React, {PropTypes} from "react";
import {connect} from "react-redux";
import Modal from "react-bootstrap/lib/Modal";
import ExitTable from "./ExitTable";
import axios from "axios";
import toastr from "toastr";
import ModalEdit from "../../hradmin/Exit/Modal";
import ModalDelete from "../../myProfile/VerticalSS/ModalExitView";
import moment from "moment";
import csvConvert from "../../../classes/csvConvert";
import Button from "react-bootstrap/lib/Button";


function convertDate(employees) {
  let emp = new Array();
  employees.map((node)=> {
    if (node.doLeaving != null) {
      node.doL = new Date(node.doLeaving);

    }
    else
      node.doL = 'NA';
    if (node.doResignation != null) {
      node.doR = new Date(node.doResignation);

    }
    else node.doR = 'NA';

    if(node.imageUrl != null){
      const img = node.imageUrl;
      const img1 = img.replace("http",'https');
      const img2 = img1.substring(0,12) + "8" + img1.substring(12 + 1)
      node.imageUrl = img2;
    }
    else
      node.imageUrl = null;

    emp.push(node)
  })
  return emp;

}

class ExitHome extends React.Component {

  constructor() {
    super();
    this.state = {employees: [], employee: null, open: false, openDelete: false, disable: true, approve: false}
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.edit = this.edit.bind(this);
    this.refresh = this.refresh.bind(this);
    this.openExit = this.openExit.bind(this);
    this.closeExit = this.closeExit.bind(this);
    this.trueDisable = this.trueDisable.bind(this);
    this.falseDisable = this.falseDisable.bind(this);
    this.closeApprove = this.closeApprove.bind(this);
    this.openApprove = this.openApprove.bind(this);
    this.downloadCsv = this.downloadCsv.bind(this);
  }

  closeApprove() {
    this.setState({approve: false});
  }

  openApprove() {
    this.setState({approve: true});
  }

  trueDisable() {
    this.setState({disable: true})
  }

  falseDisable() {
    this.setState({disable: false})
  }

  openExit() {
    this.setState({openDelete: true})
  }

  closeExit() {
    this.setState({openDelete: false})
  }

  open() {
    this.setState({open: true})
  }

  close() {
    this.setState({open: false})
  }

  edit(employee) {
    this.setState({employee: employee});
  }

  refresh() {
    axios.get(process.env.REQ_URL + "/getExitByHrbp", {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      let employees = response.data.data;
      let verticalExits = new Array();
      employees.map((node)=> {
        {
          if (node.empStatus == 'P')
            verticalExits.unshift(node);
          else
            verticalExits.push(node);
        }
      })
      employees = convertDate(verticalExits);
      this.setState({employees: employees})
    }).catch((err)=> {
    });
  }

  componentDidMount() {
    axios.get(process.env.REQ_URL + "/getExitByHrbp", {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      let employees = response.data.data;

      let verticalExits = new Array();
      employees.map((node)=> {
        {
          if (node.empStatus == 'P')
            verticalExits.unshift(node);
          else
            verticalExits.push(node);
        }
      })

      employees = convertDate(verticalExits);
      this.setState({employees: employees})
    }).catch((err)=> {

    });
  }

  downloadCsv() {
    let csvContent = new csvConvert();
    let tableData = csvContent.convertArrayOfExitObjectsToCSV({data: this.state.employees});
    console.log(tableData);
    let filename = moment(new Date()).format('YYYY-MM-DD');

    let blob = new Blob([tableData], {type: "text/csv;charset=utf-8;"});
    blob = window.URL.createObjectURL(blob);
    if (!tableData.match(/^data:text\/csv/i)) {
      tableData = 'data:text/csv;charset=utf-8,' + tableData;
    }
    let getCsv = new Promise((resolve, reject)=> {
      this.setState({csv: blob})
      resolve(true);
    });
    getCsv.then((response)=> {
      this.download.click();
    })
  }

  render() {
    return (
      <div>

        {this.state.open ? <ModalEdit employee={this.state.employee}
                                      open={this.state.open}
                                      edit={this.edit}
                                      close={this.close}
                                      url={window.location.href.indexOf("hrbp")>0 ? "/managerApprove" : "/applyExit"}
                                      empRefresh={this.props.refresh}
                                      refresh={this.refresh}/> : null}
        {this.state.openDelete ?
          <Modal
            bsSize="large"
            show={this.state.openDelete} onHide={this.closeExit}>
            <Modal.Header closeButton>
              <Modal.Title>{this.state.employee.employeeCode} : {this.state.employee.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{borderStyle: 'solid', borderWidth: '0.5px'}}>
              <ModalDelete
                employee={this.state.employee}
                empRefresh={this.props.refresh}
                remove={this.props.remove}
                disabled={this.state.disable}
                open={this.state.openDelete}
                display="none"
                edit={this.edit}
                close={this.closeExit}
                refresh={this.refresh}
              />
              &nbsp;
            </Modal.Body>
          </Modal> : null}
        {this.state.approve ? <Modal

          bsSize="medium"
          show={this.state.approve} onHide={this.closeApprove}>
          <Modal.Header closeButton>
            <Modal.Title>{this.state.employee.employeeCode} : {this.state.employee.name}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{borderStyle: 'solid', borderWidth: '0.5px'}}>
            <div style={{fontSize: '16px'}}>
              <table className="table table-bordered">
                <tbody>
                <tr>
                  <td><b><u>Date Of Resignation:</u></b></td>
                  <td>{new Date(this.state.employee.doResignation).toDateString()}</td>
                </tr>
                <tr>
                  <td><b><u>Last Working Day</u></b></td>
                  <td>{this.state.employee.doLeaving != null ? new Date(this.state.employee.doLeaving).toDateString() : null}</td>
                </tr>
                <tr>
                  <td><b><u>Type of Exit:</u></b></td>
                  <td>{this.state.employee.typeOfExit}</td>
                </tr>
                <tr>
                  <td><b><u>Notice Period Status:</u></b></td>
                  <td>{this.state.employee.noticePeriodStatus}</td>
                </tr>
                <tr>
                  <td><b><u>Reasons For Leaving:</u></b></td>
                  <td>{this.state.employee.employeeRemarks != "null" ? this.state.employee.employeeRemarks : ""}</td>
                </tr>

                </tbody>
              </table>

            </div>
            <hr/>
            <button
              onClick={()=> {
                this.setState({approve: false, url: "/managerApprove", open: true})
              }}
              className="btn btn-default">Approve
            </button>

            <button
              style={{marginLeft: '5%'}}
              onClick={()=> {
                axios.post(process.env.REQ_URL + "/managerReject", {data: {empId: this.state.employee.employeeCode,type:""}}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
                  this.setState({approve: false});
                  toastr.success("Resignation Declined");
                  this.refresh();
                }).catch((error) => {
                  console.log(error);
                });
              }}
              className="btn btn-default  ">Reject
            </button>
            &nbsp;
          </Modal.Body>
        </Modal> : null}
        <Button
          onClick={this.downloadCsv}
          style={{backgroundColor: 'rgb(92, 184, 92)'}}
        ><i className="glyphicon glyphicon-download-alt">&nbsp;</i>Download</Button>


        <a href={this.state.csv} download={"myHRBPexits" + moment(new Date()).format('YYYY-MM-DD') + ".csv"}
           ref={(input) => {
             this.download = input;
           }}/>
        <ExitTable
          trueDisable={this.trueDisable}
          falseDisable={this.falseDisable}
          edit={this.edit}
          openApprove={this.openApprove}
          open={this.open}
          openExit={this.openExit}
          employees={this.state.employees}/>
      </div>
    );
  }

}

ExitHome.propTypes = {};

function mapStateToProps(state, ownState) {
  return {
    employee: state.emp[0]
  };
}

export default connect(mapStateToProps)(ExitHome);




/** WEBPACK FOOTER **
 ** ./src/feature/hrbp/Exits/EmployeeExit.js
 **/